import React, { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Package, Plane, Handshake, MapPin } from "lucide-react";

const STEPS = [
  { icon: Package, title: "Send a Package", body: "Create a delivery request with pickup, destination, size and a photo. We'll estimate a fair price in ₹, paid as Cash on Delivery.", color: "text-blue-600 bg-blue-50" },
  { icon: Plane, title: "Travel & Deliver", body: "Heading somewhere? Post your trip and browse packages along your route to earn while you travel.", color: "text-sky-600 bg-sky-50" },
  { icon: Handshake, title: "Connect & Confirm", body: "Senders and travellers connect through offers or requests. Once accepted, chat in-app and share a secure handover PIN.", color: "text-violet-600 bg-violet-50" },
  { icon: MapPin, title: "Track & Deliver", body: "Follow the package live on the map after pickup. Enter the delivery PIN at the destination to complete it safely.", color: "text-emerald-600 bg-emerald-50" },
];

export const ONBOARDING_KEY = "pm_onboarded";

export function OnboardingGuide({ open, onClose }) {
  const [step, setStep] = useState(0);

  useEffect(() => { if (open) setStep(0); }, [open]);

  const finish = () => {
    localStorage.setItem(ONBOARDING_KEY, "1");
    onClose();
  };

  const s = STEPS[step];
  const Icon = s.icon;
  const last = step === STEPS.length - 1;

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) finish(); }}>
      <DialogContent className="sm:max-w-md" data-testid="onboarding-dialog">
        <div className="flex flex-col items-center text-center pt-2">
          <div className={`w-16 h-16 rounded-2xl flex items-center justify-center ${s.color}`}>
            <Icon className="w-8 h-8" />
          </div>
          <h2 className="mt-5 text-xl font-bold text-slate-900" data-testid="onboarding-title">{s.title}</h2>
          <p className="mt-2 text-sm text-slate-500 leading-relaxed">{s.body}</p>

          <div className="mt-6 flex items-center justify-center gap-2" data-testid="onboarding-dots">
            {STEPS.map((_, i) => (
              <span key={i} className={`h-2 rounded-full transition-all ${i === step ? "w-6 bg-primary" : "w-2 bg-slate-200"}`} />
            ))}
          </div>
        </div>

        <div className="mt-6 flex items-center justify-between gap-3">
          {step > 0 ? (
            <Button variant="outline" onClick={() => setStep((v) => v - 1)} className="rounded-xl" data-testid="onboarding-back">Back</Button>
          ) : (
            <Button variant="ghost" onClick={finish} className="rounded-xl text-slate-500" data-testid="onboarding-skip">Skip</Button>
          )}
          {last ? (
            <Button onClick={finish} className="rounded-xl flex-1 max-w-[60%]" data-testid="onboarding-get-started">Get Started</Button>
          ) : (
            <Button onClick={() => setStep((v) => v + 1)} className="rounded-xl flex-1 max-w-[60%]" data-testid="onboarding-next">Next</Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
